export const upload_package_options = [
  { label: "Allegro", value: "Package::AllegroPackage" },
  { label: "Erli", value: "Package::ErliPackage" },
  { label: "UPS", value: "Package::UpsPackage" },
  { label: "DHL", value: "Package::DhlPackage" },
  { label: "GLS", value: "Package::GlsPackage" },
  { label: "DPD", value: "Package::DpdPackage" },
  { label: "InPost", value: "Package::InPostPackage" },
  { label: "Poczta Polska", value: "Package::PocztaPolskaPackage" },
  { label: "Emag", value: "Package::EmagPackage" }
];
